export const SC_data = {
    "uk-ltd": {
        Meta_title: 'Callistus Window Fashion USA Inc | Marvel Blinds',
        OG_title: 'Callistus Window Fashion USA Inc',
        Meta_Description: 'Incorporation of Subsidiary – Callistus Window Fashion USA',
        OG_Description: 'Incorporation of Subsidiary – Callistus Window Fashion USA',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/subsidiary-company/uk-ltd/`,

        pg_title: 'Callistus Window Fashion USA Inc',
        data: [
            { title: "Incorporation of Subsidiary – Callistus Window Fashion USA", url: "/Documnets/Incorporation_Subsidiary_Callistus_Window_Fashion_USA.pdf" }
        ]
    },
    "middle-east": {
        Meta_title: 'Callistus Blinds Middle East FZE | Marvel Blinds',
        OG_title: 'Callistus Blinds Middle East FZE',
        Meta_Description: 'Audit Report – Callistus Blinds Middle East FZC – 2019 Signed-BS Audit Report_ Callistus Blinds Middle East FZC 2020_Signed BS Audit Report – Callistus Blinds Middle East FZE 2021_Signed',
        OG_Description: 'Audit Report – Callistus Blinds Middle East FZC – 2019 Signed-BS Audit Report_ Callistus Blinds Middle East FZC 2020_Signed BS Audit Report – Callistus Blinds Middle East FZE 2021_Signed',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/subsidiary-company/middle-east`,

        pg_title: 'Callistus Blinds Middle East FZE',
        data: [
            { title: "Audit Report – Callistus Blinds Middle East FZC – 2019 Signed-BS", url: "/Documnets/Audit_Report-Callistus_Blinds_Middle_East-FZC-2019_Signed-BS.pdf" },
            { title: "Audit Report_ Callistus Blinds Middle East FZC 2020_Signed BS", url: "/Documnets/Audit_Report_ Callistus_Blinds_Middle_East_FZC_2020_Signed_BS.pdf" },
            { title: "Audit Report – Callistus Blinds Middle East FZE 2021_Signed", url: "/Documnets/Audit_Report-Callistus_Blinds_Middle_East_FZE_2021_Signed.pdf" }
        ]
    }
}